import * as betprofessor from './TakeABreak.styles.betprofessor';
import * as betroyale from './TakeABreak.styles.betroyale';
import * as fiestabet from './TakeABreak.styles.fiestabet';
import * as goldenrush from './TakeABreak.styles.goldenrush';
import * as juicybet from './TakeABreak.styles.juicybet';
import * as puntcity from './TakeABreak.styles.puntcity';
import * as puntgenie from './TakeABreak.styles.puntgenie';
import * as questbet from './TakeABreak.styles.questbet';
import * as sterlingparker from './TakeABreak.styles.sterlingparker';
import * as vikingbet from './TakeABreak.styles.vikingbet';
import * as volcanobet from './TakeABreak.styles.volcanobet';
import * as junglebet from './TakeABreak.styles.junglebet';
import * as oldgill from './TakeABreak.styles.oldgill';
import * as sugarcastle from './TakeABreak.styles.sugarcastle';
import * as buffalobet from './TakeABreak.styles.buffalobet';
import * as titanbet from './TakeABreak.styles.titanbet';
import * as slambet from './TakeABreak.styles.slambet';
import * as gigabet from './TakeABreak.styles.gigabet';
import * as betstride from './TakeABreak.styles.betstride';
import * as templebet from './TakeABreak.styles.templebet';
import * as goldenbet888 from './TakeABreak.styles.goldenbet888';
import * as hyperbet from './TakeABreak.styles.hyperbet';
import * as bet777 from './TakeABreak.styles.bet777';
import * as chromabet from './TakeABreak.styles.chromabet';
import * as bet575 from './TakeABreak.styles.bet575';
import * as epicodds from './TakeABreak.styles.epicodds';
import * as pyramidbet from './TakeABreak.styles.pyramidbet';
import * as magnumbet from './TakeABreak.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
